import request from '../api';

// 用户信息
export interface IUser {
  userId?: string;
  wxname?: string;
  openid?: string;
  username?: string;
  nickname?: string;
  head?: string;
  phone?: string;
  email?: string;
  password?: string;
  confirmPassword?: string;
  memberBenefitId?: number;
}

export interface IAmount {
  amount?: string | number;
  // 充值余额
  availableRechargeBalance?: string | number;
  // 视频时长余额
  availableVideoDuration?: string | number;
  // 音频余额
  availableSoundCount?: string | number;
  // 形象定制余额
  availableImageCount?: string | number;
  // 音色定制余额
  availableVoiceCount?: string | number;
  amountType?: string;
  amountDesc?: string;
}

export function getAppUserAmountInfo() {
  return request.post('/app/user/getAppUserAmountInfo', {});
}

// 会员订单列表
export function getAppMemberBenefitOrderPage(data) {
  return request.post('/app/memberBenefitOrder/getAppMemberBenefitOrderPage', data);
}

// 资产流水列表
export function getAppUserConsumeRecordPage(data) {
  return request.post('/app/userConsumeRecord/getAppUserConsumeRecordPage', data);
}

// 修改用户信息
export function updateNicknameApi(data) {
  return request.post('/app/user/updateNickname', data);
}
export function updateHeadApi(data) {
  return request.post('/app/user/updateHead', data);
}

// 申请成为创作者
export function applyCreator(data) {
  return request.post('/app/user/applyCreator', data);
}
// 重置用户密码
export function resetAppUserPassword(data) {
  return request.post('/app/user/resetAppUserPassword', data);
}

// 修改手机号
export function updatePhone(data) {
  return request.post('/app/user/updatePhone', data);
}

// 获取会员失效时间
export function getMemberExpiresTime(data?: any) {
  return request.post('/app/user/getMemberExpiresTime', data);
}

// 获取App团队权益许可
export function getTeamBenefitCodes(data) {
  return request.post('/app/teamBenefit/getTeamBenefitCodes', data);
}

//用户资产
export function getUserResource(data = {}) {
  return request.post('/app/userResource/appUserResource', data);
}

//更新密码
export function updatePassword(data) {
  return request.post('/app/user/updatePassword', data);
}

//绑定微信公众号
export function wxBindWx() {
  return request.post('/wx/bindWx');
}

// 获取微信绑定状态
export function wxGetWxBindInfo(sceneIdStr) {
  return request.post(`/wx/getWxBindInfo/${sceneIdStr}`);
}
